import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
// import { env } from 'process';
import { SharedService } from 'src/app/services/shared.service';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})

export class DashboardBuilderService {
  
  constructor(
    private http:HttpClient,
    private sharedService:SharedService
  ){}

  headers = new HttpHeaders({ 'content-type': 'application/json','charset':'utf-8'});

  checkDashboardnameExists(dashboardname: string) {
    return this.http.post(environment.apiUrl + '/studio/dashboard_builder/name/check', JSON.stringify({ dashboard_name: dashboardname, user_name: this.sharedService.userName}), { headers: this.headers })
  }
    
  widgetsFiltersGet() {
    return this.http.post(environment.apiUrl + '/studio/dashboard_builder/filters/get', JSON.stringify({user_name: this.sharedService.userName}), { headers: this.headers })
  }

  widgetsListGet() {
    return this.http.post(environment.apiUrl + '/studio/dashboard_builder/widgets/get', JSON.stringify({user_name: this.sharedService.userName}), { headers: this.headers })
  }


  dashboardLayoutPost(req_obj:any){
    return this.http.post(environment.apiUrl + '/studio/dashboard_builder/dashboard/post',JSON.stringify(req_obj), { headers: this.headers })
  }

  dashboardWidgetDataGet(req_obj:any){
    return this.http.post(environment.apiUrl + '/studio/dashboard_builder/widget-data/get',JSON.stringify(req_obj), { headers: this.headers })
  }

  
}